import React, { useState, useEffect, useRef, useMemo } from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
  Card,
  Alert,
  Dropdown,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
} from "react-bootstrap"
import { API_WEB_URLS } from "constants/constAPI"
import { Fn_GetReport, Fn_DisplayData, Fn_FillListData } from "store/Functions"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { Search, Printer, X, LogOut, Calendar, Filter, Download } from "react-feather"
import EditContract from "../Transaction/EditContract"
import "./ContractRegister.scss"
import * as XLSX from 'xlsx'
import ExcelJS from 'exceljs'

function SellRegister() {
  const dispatch = useDispatch()

  // Get global dates from Redux store
  const globalDates = useSelector(state => state.GlobalDates)

  const [itemType, setItemType] = useState("")
  const [fromDate, setFromDate] = useState(new Date(globalDates.fromDate))
  const [toDate, setToDate] = useState(new Date(globalDates.toDate))
  const [ledgerId, setLedgerId] = useState(0)
  const [notLifted, setNotLifted] = useState(false)
  const [partialLift, setPartialLift] = useState(false)
  const [fullLift, setFullLift] = useState(false)
  const [selectedPeriods, setSelectedPeriods] = useState([])
  const [showPeriodDropdown, setShowPeriodDropdown] = useState(false)

  const [showTable, setShowTable] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showReport, setShowReport] = useState(false)
   
  const [error, setError] = useState("")

  // Checkbox selection state for multi-print
  const [selectedRows, setSelectedRows] = useState([])
  const [selectAll, setSelectAll] = useState(false)

  // Sorting state
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'asc'
  })

  // Modal state for EditContract
  const [showEditContractModal, setShowEditContractModal] = useState(false)
  const [selectedContractData, setSelectedContractData] = useState(null)
  const [modalLoading, setModalLoading] = useState(false)

  const [state, setState] = useState({
    FillArray: [],
    LedgerArray: [],
    MonthArray: [],
    FromDate: globalDates.fromDate,
    ToDate: globalDates.toDate,
  })

  // Column resizing (Excel-like)
  const defaultColumnWidths = {
    Select: 40,
    ContractNo: 130,
    Date: 110,
    BrokerLedger: 120, // default small as requested
    PartyLedger: 120,  // default small as requested
    Type: 90,
    Qty: 110,
    Rate: 110,
    ItemTypeName: 140,
    Period: 180,
    LiftedQuantity: 120,
    PendingQty: 120,
    AdvPayment: 130,
    AdvDate: 120,
    Vessel: 140,
  }

  const sellWidthsStorageKey = 'sellRegisterColumnWidths'
  const [columnWidths, setColumnWidths] = useState(() => {
    try {
      const saved = localStorage.getItem(sellWidthsStorageKey)
      const parsed = saved ? JSON.parse(saved) : {}
      return { ...defaultColumnWidths, ...parsed }
    } catch {
      return { ...defaultColumnWidths }
    }
  })

  const resizingRef = useRef({ colKey: null, startX: 0, startWidth: 0 })

  const onMouseMoveResize = (e) => {
    const { colKey, startX, startWidth } = resizingRef.current || {}
    if (!colKey) return
    const delta = e.clientX - startX
    const newWidth = Math.max(80, startWidth + delta)
    setColumnWidths(prev => ({ ...prev, [colKey]: newWidth }))
  }

  const onMouseUpResize = () => {
    if (resizingRef.current.colKey) {
      try {
        localStorage.setItem(sellWidthsStorageKey, JSON.stringify(columnWidths))
      } catch {}
    }
    resizingRef.current = { colKey: null, startX: 0, startWidth: 0 }
    document.removeEventListener('mousemove', onMouseMoveResize)
    document.removeEventListener('mouseup', onMouseUpResize)
  }

  const handleMouseDownResize = (e, colKey) => {
    e.preventDefault()
    e.stopPropagation()
    const th = e.target.closest('th')
    const startWidth = th ? th.offsetWidth : (columnWidths[colKey] || defaultColumnWidths[colKey] || 120)
    resizingRef.current = { colKey, startX: e.clientX, startWidth }
    document.addEventListener('mousemove', onMouseMoveResize)
    document.addEventListener('mouseup', onMouseUpResize)
  }

  const headerBaseStyle = { position: 'relative' }
  const withColWidth = (key, extra = {}) => ({
    ...headerBaseStyle,
    ...(extra || {}),
    width: `${(columnWidths[key] || defaultColumnWidths[key] || 120)}px`,
  })

  // Persist widths whenever they change and ensure saved before unload
  useEffect(() => {
    try {
      localStorage.setItem(sellWidthsStorageKey, JSON.stringify(columnWidths))
    } catch {}
  }, [columnWidths])

  useEffect(() => {
    const handler = () => {
      try { localStorage.setItem(sellWidthsStorageKey, JSON.stringify(columnWidths)) } catch {}
    }
    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [columnWidths])

  // Create unique commodity array from table data
  const uniqueCommodities = useMemo(() => {
    if (!state.FillArray || state.FillArray.length === 0) return []
    
    const uniqueItems = [...new Set(
      state.FillArray
        .map(item => item.ItemTypeName)
        .filter(name => name && name.trim() !== '')
    )].sort()
    
    return uniqueItems
  }, [state.FillArray])

  const API_URL_Get = `${API_WEB_URLS.ContractEditDataAppParty}/0/token`
    const API_URL_PeriodData = `${API_WEB_URLS.PeriodData}/0/token`
  const API_URL = API_WEB_URLS.MASTER + "/0/token/LedgerReportMaster"
  const API_URL1 = API_WEB_URLS.MASTER + "/0/token/ItemMaster"
  const API_URL2 = API_WEB_URLS.MASTER + "/0/token/MonthMaster"

  useEffect(() => {
    Fn_FillListData(dispatch, setState, "LedgerArray", API_URL + "/Id/0")
  const vformData = new FormData()
  vformData.append("FromDate", fromDate.toISOString().split("T")[0] || "")
  vformData.append("ToDate", toDate.toISOString().split("T")[0] || "")

 Fn_GetReport(
    dispatch,
    setState,
    "MonthArray",
    API_URL_PeriodData,
    { arguList: { id: 0, formData: vformData } },
    true
  )

  }, [dispatch])

  // Auto-show table when data is received
  useEffect(() => {
    console.log("FillArray updated:", state.FillArray)
    if (state.FillArray && state.FillArray.length > 0) {
      console.log("Setting showTable to true")
      setShowTable(true)
      setShowReport(true)
    }
  }, [state.FillArray])

  // Fetch data function
  const fetchData = async () => {
    setLoading(true)
    setError("")
    
    try {
      let vformData = new FormData()

      // Get selected period names
      const periodValue = selectedPeriods.length === 0 
        ? 'All' 
        : selectedPeriods.map(id => {
            const period = state.MonthArray.find(p => p.Id === id)
            return period ? period.Name : ''
          }).filter(name => name !== '').join(',')

      vformData.append("FromDate", fromDate.toISOString().split("T")[0] || "")
      vformData.append("ToDate", toDate.toISOString().split("T")[0] || "")
      vformData.append("LedgerId", ledgerId)
      vformData.append("SearchValue", periodValue)
      vformData.append("NotLifted", notLifted)
      vformData.append("PartialLift", partialLift)
      vformData.append("FullLift", fullLift)
      vformData.append("Filter", 0)
      vformData.append("F_ItemType", 0)
      vformData.append("Type", 2)

      const result = await Fn_GetReport(
        dispatch,
        setState,
        "FillArray",
        API_URL_Get,
        { arguList: { id: 0, formData: vformData } },
        true
      )

      // Show table after data is received
      setShowTable(true)
      setShowReport(true)
      
    } catch (error) {
      setError("Error generating report. Please try again.")
      console.error("Report generation error:", error)
    } finally {
      setLoading(false)
    }
  }

  // Auto-fetch data when filters change (excluding itemType as it's filtered on frontend)
  useEffect(() => {
    // Only fetch if MonthArray is loaded (to avoid fetching before initialization)
    if (state.MonthArray.length > 0) {
      fetchData()
    }
  }, [fromDate, toDate, ledgerId, selectedPeriods, notLifted, partialLift, fullLift, state.MonthArray])

  // Sorting function
  const handleSort = (key) => {
    setSortConfig(prevConfig => {
      if (prevConfig.key === key) {
        // If same column, toggle direction
        return {
          key,
          direction: prevConfig.direction === 'asc' ? 'desc' : 'asc'
        }
      } else {
        // If different column, start with ascending
        return {
          key,
          direction: 'asc'
        }
      }
    })
  }

  // Filter and sort table data
  const filteredTableData = useMemo(() => {
    if (!state.FillArray) return []
    
    let filtered = state.FillArray
    
    // Filter by commodity
    if (itemType && itemType !== "") {
      filtered = filtered.filter(row => row.ItemTypeName === itemType)
    }
    
    // Apply sorting
    if (sortConfig.key) {
      filtered = [...filtered].sort((a, b) => {
        const aValue = a[sortConfig.key] || ''
        const bValue = b[sortConfig.key] || ''
        
        if (aValue < bValue) {
          return sortConfig.direction === 'asc' ? -1 : 1
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'asc' ? 1 : -1
        }
        return 0
      })
    }
    
    return filtered
  }, [state.FillArray, itemType, sortConfig])

  // Reset selection when filters change
  useEffect(() => {
    setSelectedRows([])
    setSelectAll(false)
  }, [filteredTableData.length, itemType])

  // Function to determine row background color based on lifted quantity
  const getRowBackgroundColor = (row) => {
    const qty = parseFloat(row.Qty) || 0
    const liftedQty = parseFloat(row.LiftedQuantity) || 0
    
    if (qty > 0 && liftedQty === qty) {
      return '#d1ecf1' // Light blue - fully lifted
    } else if (qty > 0 && liftedQty === 0) {
      return '#e9ecef' // Light grey - not lifted
    } else if (qty > 0 && liftedQty > 0 && liftedQty < qty) {
      return '#f8d7da' // Light red - partially lifted
    }
    return 'white' // Default white background
  }

  // Function to get Period value
  const getPeriodValue = (row) => {
    // First priority: MonthName
    if (row.MonthName) {
      return row.MonthName
    }
    
    // Second priority: Shipment dates
    if (row.ShipmentFromDate || row.ShipmentToDate) {
      const fromDate = row.ShipmentFromDate ? new Date(row.ShipmentFromDate).toLocaleDateString('en-GB') : '-'
      const toDate = row.ShipmentToDate ? new Date(row.ShipmentToDate).toLocaleDateString('en-GB') : '-'
      return `${fromDate} - ${toDate}`
    }
    
    // Third priority: Lifted dates
    if (row.LiftedFromDate || row.LiftedToDate) {
      const fromDate = row.LiftedFromDate ? new Date(row.LiftedFromDate).toLocaleDateString('en-GB') : '-'
      const toDate = row.LiftedToDate ? new Date(row.LiftedToDate).toLocaleDateString('en-GB') : '-'
      return `${fromDate} - ${toDate}`
    }
    
    return '-'
  }

  // Handle select all checkbox
  const handleSelectAll = (e) => {
    const checked = e.target.checked
    setSelectAll(checked)
    if (checked) {
      // Select all rows
      setSelectedRows(filteredTableData.map(row => row.Id))
    } else {
      setSelectedRows([])
    }
  }

  // Handle individual row selection
  const handleRowSelect = (rowId) => {
    setSelectedRows(prev => {
      if (prev.includes(rowId)) {
        const newSelection = prev.filter(id => id !== rowId)
        setSelectAll(false)
        return newSelection
      } else {
        const newSelection = [...prev, rowId]
        // Check if all rows are now selected
        if (newSelection.length === filteredTableData.length) {
          setSelectAll(true)
        }
        return newSelection
      }
    })
  }

  const handleClear = () => {
    setItemType("")
    setFromDate(new Date("2024-04-01"))
    setToDate(new Date("2026-03-31"))
    setLedgerId(0)
    setNotLifted(false)
    setPartialLift(false)
    setFullLift(false)
    setSelectedPeriods([])
    setSelectedRows([])
    setSelectAll(false)

    setShowTable(false)
    setShowReport(false)
    setState({
      ...state,
      FillArray: []
    })
    setError("")
  }

  const handleExit = () => {
    window.close() // Or navigate to another page
  }

  // Modal functions for EditContract
  const openEditContractModal = contractData => {
    setSelectedContractData(contractData)
    setShowEditContractModal(true)
    setModalLoading(true)

    // Set loading to false after a short delay
    setTimeout(() => {
      setModalLoading(false)
    }, 1000)
  }

  const closeEditContractModal = () => {
    setShowEditContractModal(false)
    setSelectedContractData(null)
    setModalLoading(false)
    // Refresh the data after closing modal
    fetchData()
  }

  // Handle period selection
  const handlePeriodToggle = (periodId) => {
    setSelectedPeriods(prev => {
      if (prev.includes(periodId)) {
        return prev.filter(id => id !== periodId)
      } else {
        return [...prev, periodId]
      }
    })
  }

  const handleSelectAllPeriods = () => {
    if (selectedPeriods.length === state.MonthArray.length) {
      setSelectedPeriods([])
    } else {
      setSelectedPeriods(state.MonthArray.map(p => p.Id))
    }
  }

  const getPeriodDisplayText = () => {
    if (selectedPeriods.length === 0) {
      return 'Select Period'
    } else if (selectedPeriods.length === state.MonthArray.length) {
      return 'All Selected'
    } else if (selectedPeriods.length === 1) {
      const period = state.MonthArray.find(p => p.Id === selectedPeriods[0])
      return period ? period.Name : 'Select Period'
    } else {
      return `${selectedPeriods.length} Selected`
    }
  }

  const handleMultiPrint = async () => {
    if (selectedRows.length === 0) {
      toast.warning("Please select at least one contract to print")
      return
    }

    try {
      // Convert selected IDs to comma-separated string
      const selectedIds = selectedRows.join(',')
      
      // Open ContractPrint in a new window/tab with the selected contract IDs
      const printUrl = `/contract-print?id=${selectedIds}`
      window.open(printUrl, '_blank')
      
      // Show success message
      toast.success(`Opening print view for ${selectedRows.length} contract${selectedRows.length > 1 ? 's' : ''}`)
      
    } catch (error) {
      console.error("Print preparation error:", error)
      toast.error("Error preparing print data. Please try again.")
    }
  }

  const handleLink = () => {
    // Validate period selection
    if (selectedPeriods.length === 0) {
      toast.warning("Please select exactly one period")
      return
    }
    if (selectedPeriods.length > 1) {
      toast.warning("Please select only one period. Currently " + selectedPeriods.length + " periods are selected.")
      return
    }
    
    // Validate checkbox selection - Only Black (Not Lifted) should be selected
    if (!notLifted) {
      toast.warning("Please select Black checkbox (Not Lifted) for chain analysis")
      return
    }
    if (partialLift || fullLift) {
      toast.warning("Only Black checkbox should be selected. Please uncheck Red and Blue checkboxes")
      return
    }
    
    // Start buyback chain analysis
    handleBuybackChainAnalysis()
  }

  const handleBuybackChainAnalysis = () => {
    try {
      // Filter contracts by selected period
      const periodId = selectedPeriods[0]
      const period = state.MonthArray.find(p => p.Id === periodId)
      const periodName = period ? period.Name : 'Unknown'
      
      // Filter data by the selected period
      const periodContracts = filteredTableData.filter(contract => {
        return contract.MonthName === periodName
      })

      if (periodContracts.length === 0) {
        toast.warning(`No contracts found for period: ${periodName}`)
        return
      }

      toast.info(`Analyzing ${periodContracts.length} contracts for period: ${periodName}`)

      // Build chains
      const chains = buildChains(periodContracts)
      
      // Export to Excel
      exportChainsToExcel(chains, periodName)
      
      toast.success(`Found ${chains.buybackChains.length} buyback chains and ${chains.regularChains.length} regular chains`)
    } catch (error) {
      console.error("Chain analysis error:", error)
      toast.error("Error analyzing chains. Please try again.")
    }
  }

  const buildChains = (contracts) => {
    const usedContracts = new Set()
    const buybackChains = []
    const regularChains = []

    // Create a map of seller -> buyers with contract details
    const sellerToBuyers = {}
    contracts.forEach(contract => {
      const seller = contract.SellerLedger
      const buyer = contract.BuyerLedger
      
      if (!sellerToBuyers[seller]) {
        sellerToBuyers[seller] = []
      }
      sellerToBuyers[seller].push({
        buyer: buyer,
        contract: contract
      })
    })

    // Function to detect buyback chains (cycles)
    const findBuybackChain = (startParty, currentParty, path, visited, itemType) => {
      if (visited.has(currentParty)) {
        // Found a cycle
        if (currentParty === startParty && path.length > 1) {
          return { found: true, chain: [...path] }
        }
        return { found: false }
      }

      if (!sellerToBuyers[currentParty]) {
        return { found: false }
      }

      visited.add(currentParty)

      for (let edge of sellerToBuyers[currentParty]) {
        if (usedContracts.has(edge.contract.Id)) continue
        
        // Check if item type matches (same commodity in the chain)
        if (itemType && edge.contract.ItemTypeName !== itemType) continue
        
        const newPath = [...path, edge]
        const newItemType = itemType || edge.contract.ItemTypeName
        const result = findBuybackChain(startParty, edge.buyer, newPath, new Set(visited), newItemType)
        
        if (result.found) {
          return result
        }
      }

      return { found: false }
    }

    // First, find all buyback chains (cycles)
    const allParties = new Set()
    contracts.forEach(c => {
      allParties.add(c.SellerLedger)
      allParties.add(c.BuyerLedger)
    })

    for (let party of allParties) {
      const result = findBuybackChain(party, party, [], new Set(), null)
      
      if (result.found && result.chain.length > 0) {
        // Mark contracts as used
        const chainContractIds = result.chain.map(edge => edge.contract.Id)
        const allUsed = chainContractIds.every(id => usedContracts.has(id))
        
        if (!allUsed) {
          result.chain.forEach(edge => usedContracts.add(edge.contract.Id))
          buybackChains.push(result.chain)
        }
      }
    }

    // Function to build linear chains
    const buildLinearChain = (startContract) => {
      const chain = []
      let currentContract = startContract
      const chainItemType = startContract.ItemTypeName
      
      // Go backward to find the start of the chain
      const visited = new Set()
      while (true) {
        if (visited.has(currentContract.Id)) break
        visited.add(currentContract.Id)
        
        // Find who sold to the current seller (with same item type)
        const previousSeller = contracts.find(c => 
          !usedContracts.has(c.Id) && 
          c.BuyerLedger === currentContract.SellerLedger &&
          c.ItemTypeName === chainItemType &&
          !visited.has(c.Id)
        )
        
        if (!previousSeller) break
        currentContract = previousSeller
      }

      // Now build forward from the start
      const chainVisited = new Set()
      while (currentContract) {
        if (chainVisited.has(currentContract.Id)) break
        chainVisited.add(currentContract.Id)
        
        chain.push({
          buyer: currentContract.BuyerLedger,
          contract: currentContract
        })
        usedContracts.add(currentContract.Id)
        
        // Find next contract where buyer becomes seller (with same item type)
        const nextContract = contracts.find(c => 
          !usedContracts.has(c.Id) && 
          c.SellerLedger === currentContract.BuyerLedger &&
          c.ItemTypeName === chainItemType &&
          !chainVisited.has(c.Id)
        )
        
        currentContract = nextContract
      }
      
      return chain
    }

    // Build linear chains for remaining contracts
    contracts.forEach(contract => {
      if (!usedContracts.has(contract.Id)) {
        const chain = buildLinearChain(contract)
        if (chain.length > 0) {
          regularChains.push(chain)
        }
      }
    })

    return { buybackChains, regularChains }
  }

  // Excel export function with colorful rows and totals
  const handleExcelExport = async () => {
    if (!filteredTableData || filteredTableData.length === 0) {
      toast.warning("No data to export")
      return
    }

    if (selectedRows.length === 0) {
      toast.warning("Please select at least one row to export")
      return
    }

    // Filter data to only include selected rows
    const selectedData = filteredTableData.filter(row => selectedRows.includes(row.Id))

    try {
      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet('Contract Register')

      // Define columns
      worksheet.columns = [
        { header: 'Contract No', key: 'contractNo', width: 15 },
        { header: 'Date', key: 'date', width: 12 },
        { header: 'Broker', key: 'broker', width: 20 },
        { header: 'Party', key: 'party', width: 20 },
        { header: 'Type', key: 'type', width: 10 },
        { header: 'Qty', key: 'qty', width: 12 },
        { header: 'Rate', key: 'rate', width: 12 },
        { header: 'Item', key: 'item', width: 15 },
        { header: 'Period', key: 'period', width: 20 },
        { header: 'Lifted Qty', key: 'liftedQty', width: 12 },
        { header: 'Pending Qty', key: 'pendingQty', width: 12 },
        { header: 'Adv Payment', key: 'advPayment', width: 15 },
        { header: 'Adv Date', key: 'advDate', width: 12 },
        { header: 'Vessel', key: 'vessel', width: 15 }
      ]

      // Style header row
      const headerRow = worksheet.getRow(1)
      headerRow.font = { bold: true, color: { argb: 'FFFFFF' } }
      headerRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '28a745' } // Green background
      }
      headerRow.alignment = { horizontal: 'center', vertical: 'middle' }
      headerRow.height = 25

      // Add data rows with colors
      selectedData.forEach((row, index) => {
        const qty = parseFloat(row.Qty) || 0;
        const liftedQty = parseFloat(row.LiftedQuantity) || 0;
        const pendingQty = qty - liftedQty;

        const excelRow = worksheet.addRow({
          contractNo: row.ContractNo || '-',
          date: row.Date ? new Date(row.Date).toLocaleDateString('en-GB') : '-',
          party: row.PartyLedger || '-',
          broker: row.BrokerLedger || '-',
          type: row.Type === 1 ? 'Buy' : row.Type === 2 ? 'Sell' : '-',
          item: row.ItemTypeName || '-',
          period: getPeriodValue(row),
          qty: qty,
          rate: parseFloat(row.Rate) || 0,
          liftedQty: liftedQty,
          pendingQty: pendingQty,
          advPayment: parseFloat(row.AdvPayment) || 0,
          advDate: row.AdvDate ? new Date(row.AdvDate).toLocaleDateString('en-GB') : '-',
          vessel: row.Vessel || '-'
        })

        // Apply row styling based on lifted quantity (same colors as table)
        let fillColor = 'FFFFFF' // Default white

        if (qty > 0 && liftedQty === qty) {
          fillColor = 'D1ECF1' // Light blue - fully lifted
        } else if (qty > 0 && liftedQty === 0) {
          fillColor = 'E9ECEF' // Light grey - not lifted
        } else if (qty > 0 && liftedQty > 0 && liftedQty < qty) {
          fillColor = 'F8D7DA' // Light red - partially lifted
        }

        // Apply background color to all cells in the row
        excelRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: fillColor }
          }
          cell.border = {
            top: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } }
          }
        })

        // Style numeric columns (right align)
        excelRow.getCell('qty').alignment = { horizontal: 'right' }
        excelRow.getCell('rate').alignment = { horizontal: 'right' }
        excelRow.getCell('liftedQty').alignment = { horizontal: 'right' }
        excelRow.getCell('pendingQty').alignment = { horizontal: 'right' }
        excelRow.getCell('advPayment').alignment = { horizontal: 'right' }

        // Make contract number bold
        excelRow.getCell('contractNo').font = { bold: true }
      })

      // Add totals row
      const totalQty = selectedData.reduce((sum, row) => sum + (parseFloat(row.Qty) || 0), 0);
      const totalLiftedQty = selectedData.reduce((sum, row) => sum + (parseFloat(row.LiftedQuantity) || 0), 0);
      const totalPendingQty = totalQty - totalLiftedQty;

      const totalsRow = worksheet.addRow({
        contractNo: 'TOTAL',
        date: '',
        party: '',
        broker: '',
        type: '',
        item: '',
        period: '',
        qty: totalQty,
        rate: '',
        liftedQty: totalLiftedQty,
        pendingQty: totalPendingQty,
        advPayment: selectedData.reduce((sum, row) => sum + (parseFloat(row.AdvPayment) || 0), 0),
        advDate: '',
        vessel: ''
      })

      // Style totals row
      totalsRow.font = { bold: true, color: { argb: 'FFFFFF' } }
      totalsRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '0d6efd' } // Blue background
      }
      totalsRow.alignment = { horizontal: 'center', vertical: 'middle' }
      totalsRow.height = 25

      // Style totals row cells
      totalsRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '0d6efd' }
        }
        cell.font = { bold: true, color: { argb: 'FFFFFF' } }
        cell.border = {
          top: { style: 'thick', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thick', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
      })

      // Right align numeric columns in totals row
      totalsRow.getCell('qty').alignment = { horizontal: 'right' }
      totalsRow.getCell('liftedQty').alignment = { horizontal: 'right' }
      totalsRow.getCell('pendingQty').alignment = { horizontal: 'right' }
      totalsRow.getCell('advPayment').alignment = { horizontal: 'right' }

      // Add summary information
      worksheet.addRow({}) // Empty row
      const summaryRow = worksheet.addRow({
        contractNo: 'SUMMARY',
        date: '',
        seller: '',
        buyer: '',
        item: '',
        period: '',
        qty: '',
        rate: '',
        liftedQty: '',
        advPayment: '',
        advDate: '',
        vessel: ''
      })

      summaryRow.font = { bold: true }
      summaryRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'F8F9FA' }
      }

      // Add summary details
      const summaryDetails = [
        { label: 'Selected Contracts', value: selectedData.length },
        { label: 'Report Generated', value: new Date().toLocaleString('en-GB') },
        { label: 'Date Range', value: `${fromDate.toLocaleDateString('en-GB')} - ${toDate.toLocaleDateString('en-GB')}` }
      ]

      summaryDetails.forEach((detail, index) => {
        const detailRow = worksheet.addRow({
          contractNo: detail.label,
          date: '',
          seller: '',
          buyer: '',
          item: '',
          period: detail.value,
          qty: '',
          rate: '',
          liftedQty: '',
          advPayment: '',
          advDate: '',
          vessel: ''
        })

        detailRow.getCell('contractNo').font = { bold: true }
        detailRow.getCell('period').font = { bold: true }
      })

      // Generate filename with timestamp
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19)
      const fileName = `Contract_Register_Selected_${selectedRows.length}_rows_${timestamp}.xlsx`

      // Save the workbook
      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      
      // Create download link
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)

      toast.success(`Excel file downloaded: ${fileName}`)
    } catch (error) {
      console.error('Excel export error:', error)
      toast.error('Error exporting to Excel. Please try again.')
    }
  }

  const exportChainsToExcel = (chains, periodName) => {
    const workbook = XLSX.utils.book_new()

    // Prepare Buyback Chains data
    const buybackData = []
    chains.buybackChains.forEach((chain, index) => {
      const chainItem = chain[0].contract.ItemTypeName || 'Unknown'
      buybackData.push({
        'Chain #': `Buyback Chain ${index + 1} - ${chainItem}`,
        'Contract No': '',
        'Date': '',
        'Party': chain[0].contract.PartyLedger,
        'Broker': '',
        'Type': '',
        'Item': chainItem,
        'Qty': '',
        'Rate': '',
        'Chain Flow': ''
      })

      chain.forEach((edge, edgeIndex) => {
        const flow = edgeIndex === 0 
          ? `${edge.contract.SellerLedger} → ${edge.buyer}`
          : `→ ${edge.buyer}`
        
        buybackData.push({
          'Chain #': '',
          'Contract No': edge.contract.ContractNo,
          'Date': edge.contract.Date ? new Date(edge.contract.Date).toLocaleDateString('en-GB') : '-',
          'Party': edge.contract.PartyLedger,
          'Broker': edge.contract.BrokerLedger,
          'Type': edge.contract.Type === 1 ? 'Buy' : edge.contract.Type === 2 ? 'Sell' : '-',
          'Item': edge.contract.ItemTypeName || '-',
          'Qty': edge.contract.Qty || 0,
          'Rate': edge.contract.Rate || 0,
          'Chain Flow': flow
        })
      })

      // Add chain summary
      const chainFlow = [chain[0].contract.SellerLedger, ...chain.map(e => e.buyer)].join(' → ')
      buybackData.push({
        'Chain #': '',
        'Contract No': '',
        'Date': '',
        'Seller': '',
        'Buyer': '',
        'Item': '',
        'Qty': '',
        'Rate': '',
        'Chain Flow': `Complete: ${chainFlow}`
      })
      buybackData.push({}) // Empty row
    })

    // Prepare Regular Chains data
    const regularData = []
    chains.regularChains.forEach((chain, index) => {
      const chainItem = chain[0].contract.ItemTypeName || 'Unknown'
      regularData.push({
        'Chain #': `Regular Chain ${index + 1} - ${chainItem}`,
        'Contract No': '',
        'Date': '',
        'Party': chain[0].contract.PartyLedger,
        'Broker': '',
        'Type': '',
        'Item': chainItem,
        'Qty': '',
        'Rate': '',
        'Chain Flow': ''
      })

      chain.forEach((edge, edgeIndex) => {
        const flow = edgeIndex === 0 
          ? `${edge.contract.SellerLedger} → ${edge.buyer}`
          : `→ ${edge.buyer}`
        
        regularData.push({
          'Chain #': '',
          'Contract No': edge.contract.ContractNo,
          'Date': edge.contract.Date ? new Date(edge.contract.Date).toLocaleDateString('en-GB') : '-',
          'Party': edge.contract.PartyLedger,
          'Broker': edge.contract.BrokerLedger,
          'Type': edge.contract.Type === 1 ? 'Buy' : edge.contract.Type === 2 ? 'Sell' : '-',
          'Item': edge.contract.ItemTypeName || '-',
          'Qty': edge.contract.Qty || 0,
          'Rate': edge.contract.Rate || 0,
          'Chain Flow': flow
        })
      })

      // Add chain summary
      const chainFlow = [chain[0].contract.SellerLedger, ...chain.map(e => e.buyer)].join(' → ')
      regularData.push({
        'Chain #': '',
        'Contract No': '',
        'Date': '',
        'Seller': '',
        'Buyer': '',
        'Item': '',
        'Qty': '',
        'Rate': '',
        'Chain Flow': `Complete: ${chainFlow}`
      })
      regularData.push({}) // Empty row
    })

    // Create worksheets
    if (buybackData.length > 0) {
      const buybackSheet = XLSX.utils.json_to_sheet(buybackData)
      XLSX.utils.book_append_sheet(workbook, buybackSheet, 'Buyback Chains')
    }

    if (regularData.length > 0) {
      const regularSheet = XLSX.utils.json_to_sheet(regularData)
      XLSX.utils.book_append_sheet(workbook, regularSheet, 'Regular Chains')
    }

    // Create summary sheet
    const summaryData = [
      { 'Description': 'Period', 'Value': periodName },
      { 'Description': 'Total Buyback Chains', 'Value': chains.buybackChains.length },
      { 'Description': 'Total Regular Chains', 'Value': chains.regularChains.length },
      { 'Description': 'Total Contracts in Buyback Chains', 'Value': chains.buybackChains.reduce((sum, chain) => sum + chain.length, 0) },
      { 'Description': 'Total Contracts in Regular Chains', 'Value': chains.regularChains.reduce((sum, chain) => sum + chain.length, 0) },
      { 'Description': 'Report Generated', 'Value': new Date().toLocaleString('en-GB') }
    ]
    const summarySheet = XLSX.utils.json_to_sheet(summaryData)
    XLSX.utils.book_append_sheet(workbook, summarySheet, 'Summary')

    // Download the file
    const fileName = `Chain_Analysis_${periodName.replace(/\s+/g, '_')}_${new Date().getTime()}.xlsx`
    XLSX.writeFile(workbook, fileName)

    toast.success(`Excel file downloaded: ${fileName}`)
  }

  const handlePrint = () => {
    // Create a new window with only the table data
    const printWindow = window.open('', '_blank', 'width=1200,height=800')
    
    if (printWindow) {
      const tableData = filteredTableData
      
      const printContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Contract Register Report</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              margin: 20px; 
              font-size: 12px;
            }
            .header {
              text-align: center;
              margin-bottom: 20px;
              border-bottom: 2px solid #333;
              padding-bottom: 10px;
            }
            .header h1 {
              margin: 0;
              color: #333;
              font-size: 24px;
            }
            .header p {
              margin: 5px 0;
              color: #666;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
              font-size: 11px;
            }
            th {
              background-color: #f2f2f2;
              font-weight: bold;
              text-align: center;
            }
            .text-end { text-align: right; }
            .text-center { text-align: center; }
            .fw-semibold { font-weight: 600; }
            @media print {
              body { margin: 0; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>Contract Register Report</h1>
            <p>Generated on: ${new Date().toLocaleDateString('en-GB')} at ${new Date().toLocaleTimeString('en-GB')}</p>
          </div>
          
          <table>
            <thead>
              <tr>
                <th>Contract No</th>
                <th>Date</th>
                <th>Broker</th>
                <th>Party</th>
                <th>Type</th>
                <th>Qty</th>
                <th>Rate</th>
                <th>Item</th>
                <th>Period</th>
                <th>Lifted Qty</th>
                <th>Pending Qty</th>
                <th>Adv Payment</th>
                <th>Adv Date</th>
                <th>Vessel</th>
              </tr>
            </thead>
            <tbody>
              ${tableData.map(row => {
                const qty = parseFloat(row.Qty) || 0
                const liftedQty = parseFloat(row.LiftedQuantity) || 0
                const pendingQty = qty - liftedQty
                let bgColor = 'transparent'
                
                if (liftedQty === qty && qty > 0) {
                  bgColor = '#d1ecf1' // Light blue - fully lifted
                } else if (liftedQty === 0) {
                  bgColor = '#e9ecef' // Light grey - not lifted
                } else if (liftedQty > 0 && liftedQty < qty) {
                  bgColor = '#f8d7da' // Light red - partially lifted
                }
                
                // Get Period value
                let periodValue = '-'
                if (row.MonthName) {
                  periodValue = row.MonthName
                } else if (row.ShipmentFromDate || row.ShipmentToDate) {
                  const fromDate = row.ShipmentFromDate ? new Date(row.ShipmentFromDate).toLocaleDateString('en-GB') : '-'
                  const toDate = row.ShipmentToDate ? new Date(row.ShipmentToDate).toLocaleDateString('en-GB') : '-'
                  periodValue = `${fromDate} - ${toDate}`
                } else if (row.LiftedFromDate || row.LiftedToDate) {
                  const fromDate = row.LiftedFromDate ? new Date(row.LiftedFromDate).toLocaleDateString('en-GB') : '-'
                  const toDate = row.LiftedToDate ? new Date(row.LiftedToDate).toLocaleDateString('en-GB') : '-'
                  periodValue = `${fromDate} - ${toDate}`
                }
                
                return `
                <tr style="background-color: ${bgColor}">
                  <td class="fw-semibold">${row.ContractNo || '-'}</td>
                  <td>${row.Date ? new Date(row.Date).toLocaleDateString('en-GB') : '-'}</td>
                  <td>${row.BrokerLedger || '-'}</td>
                  <td>${row.PartyLedger || '-'}</td>
                  <td>${row.Type === 1 ? 'Buy' : row.Type === 2 ? 'Sell' : '-'}</td>
                  <td class="text-end fw-semibold">${row.Qty ? row.Qty.toLocaleString() : '0'}</td>
                  <td class="text-end fw-semibold">${row.Rate ? row.Rate.toLocaleString() : '0'}</td>
                  <td>${row.ItemTypeName || '-'}</td>
                  <td>${periodValue}</td>
                  <td class="text-end fw-semibold">${row.LiftedQuantity ? row.LiftedQuantity.toLocaleString() : '0'}</td>
                  <td class="text-end fw-semibold">${pendingQty.toLocaleString()}</td>
                  <td class="text-end fw-semibold">${row.AdvPayment ? row.AdvPayment.toLocaleString() : '0'}</td>
                  <td>${row.AdvDate ? new Date(row.AdvDate).toLocaleDateString('en-GB') : '-'}</td>
                  <td>${row.Vessel || '-'}</td>
                </tr>
              `}).join('')}
            </tbody>
          </table>
        </body>
        </html>
      `
      
      printWindow.document.write(printContent)
      printWindow.document.close()
      
      // Wait for content to load then print
      printWindow.onload = () => {
        printWindow.print()
        printWindow.close()
      }
    }
  }

  return (
    <div  style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      height: 'calc(100vh - 70px)',
      padding: 0,
      margin: 0,
      overflow: 'hidden',
      gap: 0
    }}>

      {/* Filter Form */}
      <Card className="shadow-sm border-0" style={{ flexShrink: 0, marginBottom: '0.5rem' }}>
        <Card.Header className="bg-primary text-white py-2">
          <h6 className="mb-0 d-flex align-items-center">
            <Filter className="me-2" size={16} />
            Contract Register
          </h6>
        </Card.Header>
        <Card.Body className="py-2 px-3" style={{ overflow: 'visible' }}>
          <Form>
            <Row className="g-2 align-items-end">
              <Col lg={1} md={2} sm={3}>
                <Form.Label className="fw-semibold mb-1 small">Ledger</Form.Label>
                <Form.Select
                  value={ledgerId}
                  onChange={e => setLedgerId(e.target.value)}
                  className="form-select-sm"
                  style={{ fontSize: '0.8rem' }}
                >
                  <option value={0}>All</option>
                  {state.LedgerArray.map(ledger => (
                    <option key={ledger.Id} value={ledger.Id}>
                      {ledger.Name}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col lg={1} md={2} sm={3}>
                <Form.Label className="fw-semibold mb-1 small">
                  From Date
                </Form.Label>
                <DatePicker
                  selected={fromDate}
                  onChange={date => setFromDate(date)}
                  className="form-control form-control-sm"
                  dateFormat="dd/MM/yyyy"
                  placeholderText="From Date"
                  portalId="root-portal"
                  popperPlacement="bottom-start"
                  style={{ fontSize: '0.8rem' }}
                />
              </Col>
              <Col lg={1} md={2} sm={3}>
                <Form.Label className="fw-semibold mb-1 small">
                  To Date
                </Form.Label>
                <DatePicker
                  selected={toDate}
                  onChange={date => setToDate(date)}
                  className="form-control form-control-sm"
                  dateFormat="dd/MM/yyyy"
                  placeholderText="To Date"
                  portalId="root-portal"
                  popperPlacement="bottom-start"
                  style={{ fontSize: '0.8rem' }}
                />
              </Col>
              <Col lg={1} md={2} sm={3}>
                <Form.Label className="fw-semibold mb-1 small">Commodity</Form.Label>
                <Form.Select
                  value={itemType}
                  onChange={e => setItemType(e.target.value)}
                  className="form-select-sm"
                  style={{ fontSize: '0.8rem' }}
                >
                  <option value="">All</option>
                  {uniqueCommodities.map((commodity, index) => (
                    <option key={index} value={commodity}>
                      {commodity}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              
              <Col lg={1} md={2} sm={3} style={{ position: 'relative', zIndex: 1000 }}>
                <Form.Label className="fw-semibold mb-1 small">Period</Form.Label>
                <Dropdown 
                  show={showPeriodDropdown} 
                  onToggle={(isOpen) => setShowPeriodDropdown(isOpen)}
                  drop="down"
                  align="start"
                >
                  <Dropdown.Toggle 
                    variant="outline-secondary" 
                    size="sm" 
                    className="w-100 text-start d-flex justify-content-between align-items-center"
                    style={{ fontSize: '0.8rem', padding: '0.25rem 0.5rem' }}
                  >
                    <span className="text-truncate">{getPeriodDisplayText()}</span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu 
                    style={{ 
                      maxHeight: '250px', 
                      overflowY: 'auto', 
                      minWidth: '200px',
                      zIndex: 9999,
                      position: 'absolute'
                    }}
                  >
                    <Dropdown.Item 
                      onClick={(e) => {
                        e.stopPropagation()
                        handleSelectAllPeriods()
                      }}
                      style={{ padding: '0.5rem 1rem' }}
                    >
                      <Form.Check 
                        type="checkbox"
                        label="Select All"
                        checked={selectedPeriods.length === state.MonthArray.length}
                        onChange={() => {}}
                        style={{ pointerEvents: 'none' }}
                      />
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    {state.MonthArray.map(period => (
                      <Dropdown.Item 
                        key={period.Id}
                        onClick={(e) => {
                          e.stopPropagation()
                          handlePeriodToggle(period.Id)
                        }}
                        style={{ padding: '0.5rem 1rem' }}
                      >
                        <Form.Check 
                          type="checkbox"
                          label={period.Name}
                          checked={selectedPeriods.includes(period.Id)}
                          onChange={() => {}}
                          style={{ pointerEvents: 'none' }}
                        />
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
             
              <Col xs="auto" className="d-flex align-items-end">
                <div style={{ 
                  border: '1px solid #000000', 
                  borderRadius: '4px', 
                  padding: '0.25rem 0.5rem',
                  backgroundColor: '#f8f9fa',
                  width: 'fit-content'
                }}>
                 
                  <div className="d-flex gap-2">
                    <Form.Check
                      type="checkbox"
                      checked={notLifted}
                      onChange={e => setNotLifted(e.target.checked)}
                      className="form-check-input-sm"
                      label={<span style={{ color: '#000000', fontSize: '0.75rem', fontWeight: '500' }}>Unlifted</span>}
                    />
                    <Form.Check
                      type="checkbox"
                      checked={partialLift}
                      onChange={e => setPartialLift(e.target.checked)}
                      className="form-check-input-sm"
                      label={<span style={{ color: '#dc3545', fontSize: '0.75rem', fontWeight: '500' }}>Partially Lifted</span>}
                    />
                    <Form.Check
                      type="checkbox"
                      checked={fullLift}
                      onChange={e => setFullLift(e.target.checked)}
                      className="form-check-input-sm"
                      label={<span style={{ color: '#0d6efd', fontSize: '0.75rem', fontWeight: '500' }}>Fully Lifted</span>}
                    />
                  </div>
                </div>
              </Col>

              <Col xs="auto" className="d-flex align-items-end">
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={handleClear}
                  className="d-flex align-items-center w-100"
                  style={{ fontSize: '0.8rem', padding: '0.25rem 0.5rem' }}
                >
                  <X className="me-1" size={14} />
                  Clear
                </Button>
              </Col>

              <Col xs="auto" className="d-flex align-items-end">
                <Button 
                  variant="outline-primary" 
                  size="sm" 
                  onClick={handleMultiPrint}
                  className="d-flex align-items-center"
                  style={{ fontSize: '0.8rem', padding: '0.25rem 0.5rem' }}
                  disabled={selectedRows.length === 0}
                >
                  <Printer className="me-1" size={14} />
                  Print {selectedRows.length > 0 ? `(${selectedRows.length})` : ''}
                </Button>
              </Col>
              <Col xs="auto" className="d-flex align-items-end">
                <Button 
                  variant="outline-success" 
                  size="sm" 
                  onClick={handleExcelExport}
                  className="d-flex align-items-center"
                  style={{ fontSize: '0.8rem', padding: '0.25rem 0.5rem' }}
                  disabled={selectedRows.length === 0}
                  title="Export selected rows to Excel with colorful rows and totals"
                >
                  <Download className="me-1" size={14} />
                  Excel
                </Button>
              </Col>
              {/* <Col xs="auto" className="d-flex align-items-end">
                <Button 
                  variant="outline-info" 
                  size="sm" 
                  onClick={handleLink}
                  className="d-flex align-items-center"
                  style={{ fontSize: '0.8rem', padding: '0.25rem 0.5rem' }}
                  disabled={selectedPeriods.length !== 1 || !notLifted || partialLift || fullLift}
                  title={
                    selectedPeriods.length !== 1 
                      ? "Select exactly one period" 
                      : (!notLifted || partialLift || fullLift)
                        ? "Only Black checkbox should be selected"
                        : "Analyze buyback chains"
                  }
                >
                  <i className="fas fa-link me-1" style={{ fontSize: '12px' }}></i>
                  Link
                </Button>
              </Col> */}
              <Col xs="auto" className="d-flex align-items-end">
                <Button 
                  variant="outline-danger" 
                  size="sm" 
                  onClick={handleExit}
                  className="d-flex align-items-center"
                  style={{ fontSize: '0.8rem', padding: '0.25rem 0.5rem' }}
                >
                  <LogOut className="me-1" size={14} />
                  Exit
                </Button>
              </Col>

              <Col xs="auto" className="d-flex align-items-end ms-auto">
                <div style={{ 
                  border: '2px solid #0d6efd', 
                  borderRadius: '4px', 
                  padding: '0.3rem 0.6rem',
                  backgroundColor: '#e7f1ff',
                  display: 'flex',
                  gap: '1rem'
                }}>
                  <div className="text-center">
                    <div style={{ fontSize: '0.65rem', color: '#6c757d', fontWeight: '600' }}>Total Contracts</div>
                    <div style={{ fontSize: '0.9rem', color: '#0d6efd', fontWeight: 'bold' }}>
                      {filteredTableData.length.toLocaleString()}
                    </div>
                  </div>
                  <div style={{ borderLeft: '1px solid #0d6efd' }}></div>
                  <div className="text-center">
                    <div style={{ fontSize: '0.65rem', color: '#6c757d', fontWeight: '600' }}>Total Qty</div>
                    <div style={{ fontSize: '0.9rem', color: '#0d6efd', fontWeight: 'bold' }}>
                      {filteredTableData.reduce((sum, row) => sum + (parseFloat(row.Qty) || 0), 0).toLocaleString()}
                    </div>
                  </div>
                  <div style={{ borderLeft: '1px solid #0d6efd' }}></div>
                  <div className="text-center">
                    <div style={{ fontSize: '0.65rem', color: '#6c757d', fontWeight: '600' }}>Pending Qty</div>
                    <div style={{ fontSize: '0.9rem', color: '#0d6efd', fontWeight: 'bold' }}>
                      {(() => {
                        const totalQty = filteredTableData.reduce((sum, row) => sum + (parseFloat(row.Qty) || 0), 0);
                        const totalLifted = filteredTableData.reduce((sum, row) => sum + (parseFloat(row.LiftedQuantity) || 0), 0);
                        return (totalQty - totalLifted).toLocaleString();
                      })()}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      
      {/* Results Table */}
      {(showTable || (filteredTableData && filteredTableData.length > 0)) && (
        
        <div  style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, padding: 0, margin: 0 }}>
            {filteredTableData.length > 0 ? (
              <>
                {/* Selection Counter */}
          
                
                <div className="table-container" style={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
                <Table
                  bordered
                  size="sm"
                  className="mb-0 fixed-table"
                  style={{ tableLayout: 'fixed', width: '100%' }}
                >
                    <thead className="table-success text-center" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                    <tr>
                      <th style={withColWidth('Select')}>
                        <Form.Check
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                          title="Select All"
                        />
                      </th>
                      <th style={withColWidth('ContractNo')}>Contract No
                        <span
                          onMouseDown={(e) => handleMouseDownResize(e, 'ContractNo')}
                          style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: '6px', cursor: 'col-resize', userSelect: 'none' }}
                        />
                      </th>
                      <th style={withColWidth('Date')}>Date
                        <span
                          onMouseDown={(e) => handleMouseDownResize(e, 'Date')}
                          style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: '6px', cursor: 'col-resize', userSelect: 'none' }}
                        />
                      </th>
                      <th 
                        style={withColWidth('BrokerLedger')}
                      >
                        Broker
                        <span
                          onMouseDown={(e) => handleMouseDownResize(e, 'BrokerLedger')}
                          style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: '6px', cursor: 'col-resize', userSelect: 'none' }}
                        />
                      </th>
                      <th 
                        style={withColWidth('PartyLedger')}
                      >
                        Party
                        <span
                          onMouseDown={(e) => handleMouseDownResize(e, 'PartyLedger')}
                          style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: '6px', cursor: 'col-resize', userSelect: 'none' }}
                        />
                      </th>
                      
                      <th style={withColWidth('Qty')}>Qty<span onMouseDown={(e) => handleMouseDownResize(e, 'Qty')} style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: '6px', cursor: 'col-resize', userSelect: 'none' }} /></th>
                      <th style={withColWidth('Rate')}>Rate<span onMouseDown={(e) => handleMouseDownResize(e, 'Rate')} style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: '6px', cursor: 'col-resize', userSelect: 'none' }} /></th>
                      <th style={withColWidth('ItemTypeName')}>Item<span onMouseDown={(e) => handleMouseDownResize(e, 'ItemTypeName')} style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: '6px', cursor: 'col-resize', userSelect: 'none' }} /></th>
                      <th style={withColWidth('Period')}>Period<span onMouseDown={(e) => handleMouseDownResize(e, 'Period')} style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: '6px', cursor: 'col-resize', userSelect: 'none' }} /></th>
                      <th style={withColWidth('LiftedQuantity')}>Lifted Qty<span onMouseDown={(e) => handleMouseDownResize(e, 'LiftedQuantity')} style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: '6px', cursor: 'col-resize', userSelect: 'none' }} /></th>
                      <th style={withColWidth('PendingQty')}>Pending Qty<span onMouseDown={(e) => handleMouseDownResize(e, 'PendingQty')} style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: '6px', cursor: 'col-resize', userSelect: 'none' }} /></th>
                      <th style={withColWidth('AdvPayment')}>Adv Payment<span onMouseDown={(e) => handleMouseDownResize(e, 'AdvPayment')} style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: '6px', cursor: 'col-resize', userSelect: 'none' }} /></th>
                      <th style={withColWidth('AdvDate')}>Adv Date<span onMouseDown={(e) => handleMouseDownResize(e, 'AdvDate')} style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: '6px', cursor: 'col-resize', userSelect: 'none' }} /></th>
                      <th style={withColWidth('Vessel')}>Vessel<span onMouseDown={(e) => handleMouseDownResize(e, 'Vessel')} style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: '6px', cursor: 'col-resize', userSelect: 'none' }} /></th>
                    </tr>
                  </thead>
                  <tbody>
                      {filteredTableData.map((row, i) => {
                        const bgColor = getRowBackgroundColor(row);
                        return (
                        <tr key={i}>
                          <td style={{ backgroundColor: bgColor, textAlign: 'center' }}>
                            <Form.Check
                              type="checkbox"
                              checked={selectedRows.includes(row.Id)}
                              onChange={() => handleRowSelect(row.Id)}
                              onClick={e => e.stopPropagation()}
                            />
                          </td>
                          <td className="fw-semibold" style={{ backgroundColor: bgColor, maxWidth: `${columnWidths.ContractNo}px`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {row.ContractNo ? (
                              <Button
                                variant="link"
                                className="p-0 text-decoration-none"
                                onClick={(event) => {
                                  const button = event.target.closest("button")
                                  const originalText = button.innerHTML
                                  button.innerHTML = '<i class="fas fa-spinner fa-spin me-1"></i>Loading...'
                                  button.disabled = true

                                  setTimeout(() => {
                                    openEditContractModal(row)
                                    button.innerHTML = originalText
                                    button.disabled = false
                                  }, 300)
                                }}
                                title={`Click to edit contract: ${row.ContractNo}`}
                                tabIndex={0}
                                role="button"
                                aria-label={`Edit contract ${row.ContractNo}`}
                              >
                                <i className="fas fa-edit text-primary me-1"></i>
                                <span>{row.ContractNo}</span>
                              </Button>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td style={{ backgroundColor: bgColor, maxWidth: `${columnWidths.Date}px`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {row.Date ? new Date(row.Date).toLocaleDateString('en-GB') : '-'}
                          </td>
                          <td style={{ backgroundColor: bgColor, maxWidth: `${columnWidths.BrokerLedger}px`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {row.BrokerLedger || '-'}
                          </td>
                          <td style={{ backgroundColor: bgColor, maxWidth: `${columnWidths.PartyLedger}px`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {row.PartyLedger || '-'}
                          </td>
                          
                          <td className="text-end fw-semibold" style={{ backgroundColor: bgColor, maxWidth: `${columnWidths.Qty}px`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {row.Qty ? row.Qty.toLocaleString() : '0'}
                          </td>
                          <td className="text-end fw-semibold" style={{ backgroundColor: bgColor, maxWidth: `${columnWidths.Rate}px`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {row.Rate ? row.Rate.toLocaleString() : '0'}
                          </td>
                          <td style={{ backgroundColor: bgColor, maxWidth: `${columnWidths.ItemTypeName}px`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {row.ItemTypeName || '-'}
                          </td>
                          <td style={{ backgroundColor: bgColor, maxWidth: `${columnWidths.Period}px`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {getPeriodValue(row)}
                          </td>
                          <td className="text-end fw-semibold" style={{ backgroundColor: bgColor, maxWidth: `${columnWidths.LiftedQuantity}px`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {row.LiftedQuantity ? row.LiftedQuantity.toLocaleString() : '0'}
                          </td>
                          <td className="text-end fw-semibold" style={{ backgroundColor: bgColor, maxWidth: `${columnWidths.PendingQty}px`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {(() => {
                              const qty = parseFloat(row.Qty) || 0;
                              const liftedQty = parseFloat(row.LiftedQuantity) || 0;
                              const pendingQty = qty - liftedQty;
                              return pendingQty.toLocaleString();
                            })()}
                          </td>
                          <td className="text-end fw-semibold" style={{ backgroundColor: bgColor, maxWidth: `${columnWidths.AdvPayment}px`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {row.AdvPayment ? row.AdvPayment.toLocaleString() : '0'}
                          </td>
                          <td style={{ backgroundColor: bgColor, maxWidth: `${columnWidths.AdvDate}px`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {row.AdvDate ? new Date(row.AdvDate).toLocaleDateString('en-GB') : '-'}
                          </td>
                          <td style={{ backgroundColor: bgColor, maxWidth: `${columnWidths.Vessel}px`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {row.Vessel || '-'}
                          </td>
                        </tr>
                      )})}
                  </tbody>
                </Table>
              </div>
            </>
            ) : (
              <div className="text-center p-3">
                <div className="text-muted">
                  <Search size={36} className="mb-2" />
                  <h6>No Data Found</h6>
                  <p className="small mb-0">
                    No records match the selected criteria. Please try adjusting your filters.
                  </p>
                </div>
              </div>
            )}
        </div>
      )}

      {/* EditContract Modal */}
      <Modal
        show={showEditContractModal}
        onHide={closeEditContractModal}
        size="xl"
        fullscreen="lg-down"
        centered
        className="edit-contract-modal"
        style={{ zIndex: 9999 }}
      >
        <ModalHeader className="bg-primary text-white">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>
              <h5 className="mb-0">
                <i className="fas fa-edit me-2"></i>
                Edit Contract: {selectedContractData?.ContractNo || "Unknown"}
                {modalLoading && (
                  <Spinner
                    animation="border"
                    size="sm"
                    className="ms-2 text-light"
                  />
                )}
              </h5>
            </div>
            <Button
              variant="light"
              onClick={closeEditContractModal}
              className="btn-sm"
              title="Back to Report"
            >
              <i className="fas fa-arrow-left me-1"></i>
              Back to Report
            </Button>
          </div>
        </ModalHeader>
        <ModalBody
          className="p-0"
          style={{ minHeight: "70vh", maxHeight: "80vh" }}
        >
          {selectedContractData && (
            <>
              <EditContract
                isModal={true}
                contractData={selectedContractData}
                onClose={closeEditContractModal}
              />
            </>
          )}
        </ModalBody>
      </Modal>

      {/* Loading State - Overlay */}
      {loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3 text-muted small mb-0" style={{ fontSize: '1rem', fontWeight: 500 }}>Generating report, please wait...</p>
        </div>
      )}
    </div>
  )
}

export default SellRegister
